module.exports = __webpack_public_path__ + "static/media/Tsareena_gaussian2.125a2e8f.png";